export default __webpack_public_path__ + "static/media/work8.9600aa96.jpeg";